import { FormControl } from '@angular/forms';
import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.component';

export interface MessageForm {
  id: FormControl<number | null>;
  headerText: FormControl<string>;
  bodyText: FormControl<string>;
  hasDateTime: FormControl<boolean>;
  displayType: FormControl<IOption>;
  startDate: FormControl<Date>;
  endDate: FormControl<Date>;
  startTime: FormControl<string>;
  endTime: FormControl<string>;
}

export interface MessageModalInput {
  data: HomeMessage | undefined;
  edit: boolean;
}

export interface GetMessage {
  code: number;
  status: string;
  response: {
    message: HomeMessage;
  };
}

export interface HomeMessage {
  id: number | null;
  header: string;
  body: string;
  displayType: MESSAGE_TYPE;
  start: Date | null;
  end: Date | null;
}

export interface GetAllMessages {
  code: number;
  status: string;
  response: {
    messages: HomeMessage[];
  };
}

export enum MESSAGE_TYPE {
  INFO,
  NOTICE,
  ALERT,
}
